import { Address } from '@src/core/buyerApiClient';
import countries from '@src/data/countries.json';
import BrasilApi from '@src/services/BrasilApi';

export const lockDateOn = (minutes: number) => {
  const date = new Date();
  date.setMinutes(date.getMinutes() + minutes);
  return date.toISOString();
};

export enum CountryCode {
  BRAZIL = 'BRA',
  ARGENTINA = 'ARG',
  URUGUAY = 'URY',
  PARAGUAY = 'PRY',
}

export const getSortedCountries = () => {
  return countries.sort((a, b) => a.name.localeCompare(b.name));
};

export const getSortedCountriesExcludingBrazil = () => {
  return getSortedCountries().filter((country) => country.alpha3 !== CountryCode.BRAZIL);
};

export const findCountryByAlpha3Code = (alpha3: string) => {
  return countries.find((country) => country.alpha3 === alpha3);
};

export const isMercoSulExcludingBrazil = (alpha3: string) => {
  return [CountryCode.ARGENTINA, CountryCode.URUGUAY, CountryCode.PARAGUAY].includes(alpha3 as CountryCode);
};

export const initialAddressValues: Address = {
  state: null,
  city: null,
  street: null,
  district: null,
  number: null,
  complement: null,
  zipCode: null,
};

export const getCepAddress = async (cep: string): Promise<Address> => {
  try {
    const { data } = await BrasilApi.getAddressByCep({ cep });

    if (data?.cep) {
      return {
        state: data.state ?? null,
        city: data.city ?? null,
        street: data.street ?? null,
        district: data.neighborhood ?? null,
        number: data.number ? String(data.number) : null,
        complement: data.complement ?? null,
        zipCode: data.cep ?? null,
      };
    } else {
      throw new Error('Address not found');
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};
